/**
 * 明細テーブル系画面（受給者編集 / 受給者新規 / 取込エラー修正）で
 * テーブル下部に表示する共通エラーサマリーパネル。
 *
 * 1エラー = 1行のフラット表示で、入力テーブルを潰さないよう内部スクロール。
 */
export interface DetailErrorEntry {
  /** React key */
  key: string
  /** 行番号（任意。明細1始まり / CSV原本行など、画面ごとに意味が違うのでラベルもあわせる） */
  lineNo?: number | string
  /** 項目名（例: 世帯識別符号） */
  label: string
  /** エラー詳細 */
  message: string
}

interface DetailErrorSummaryProps {
  entries: DetailErrorEntry[]
  /** 行番号の前置きラベル。デフォルト「行」。明細を「明細 N行目」表記したい場合などに利用。 */
  lineLabel?: string
  /** タイトル接頭辞。「エラーがあります」のように表示。デフォルト「エラーがあります」。 */
  title?: string
  /** 上端の縁取りで親パネルと一体化させたい時。 */
  attached?: boolean
}

export default function DetailErrorSummary({
  entries,
  lineLabel = '行',
  title = 'エラーがあります',
  attached = false,
}: DetailErrorSummaryProps) {
  if (entries.length === 0) return null

  const erroneousLines = new Set(
    entries.map((e) => (e.lineNo != null ? String(e.lineNo) : '')).filter((v) => v !== ''),
  )
  const lineCountText = erroneousLines.size > 0 ? ` / ${erroneousLines.size}行` : ''

  return (
    <div
      className={
        attached
          ? 'border-t border-red-200 bg-red-50'
          : 'mt-3 rounded-lg border border-red-200 bg-red-50 shrink-0'
      }
    >
      <p className="text-xs font-medium text-red-700 px-3 py-1.5 border-b border-red-200">
        {title}（{entries.length}件{lineCountText}）
      </p>
      <ul className="max-h-24 overflow-auto px-3 py-1.5 space-y-0.5">
        {entries.map((entry) => (
          <li key={entry.key} className="text-xs text-red-700 leading-snug">
            {entry.lineNo != null ? (
              <>
                <span className="font-mono">
                  {lineLabel} {entry.lineNo}
                </span>
                <span className="mx-1.5 text-red-300">|</span>
              </>
            ) : null}
            ・「{entry.label}」: {entry.message}
          </li>
        ))}
      </ul>
    </div>
  )
}
